import {useSelector} from 'react-redux';
import Selector from '../../../../../selectors/modals/facebook/invite';
import {getInviteLink} from '../../../../../utils/user';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {toast} from 'react-toastify';

export default () => {
    const {user} = useSelector(Selector);

    return (
        <div className="facebook-invite">
            <div className="top">
                <div className="title">Earn on your Share's</div>
                <div className="text">Specify your referral link with share to earn income from your players.</div>
            </div>
            <CopyToClipboard text={`https://${getInviteLink(user.type, user.referral_code)}`} onCopy={e => {
                toast.dismiss();
                toast.info(`Your referral link has been copied to the clipboard!`);
            }}>
                <div className="field">
                    <span>https://{getInviteLink(user.type, user.referral_code)}</span>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.6654 8.60016V11.4002C10.6654 13.7335 9.73203 14.6668 7.3987 14.6668H4.5987C2.26536 14.6668 1.33203 13.7335 1.33203 11.4002V8.60016C1.33203 6.26683 2.26536 5.3335 4.5987 5.3335H7.3987C9.73203 5.3335 10.6654 6.26683 10.6654 8.60016Z" fill="#59EF79"/>
                        <path d="M11.3992 1.3335H8.59916C6.53249 1.3335 5.59916 2.06683 5.39916 3.80016C5.3325 4.20016 5.66583 4.46683 6.06583 4.46683H7.46583C10.2658 4.46683 11.5325 5.7335 11.5325 8.5335V10.0002C11.5325 10.4002 11.8658 10.6668 12.1992 10.6668C13.9325 10.4668 14.6658 9.53349 14.6658 7.46683V4.60016C14.6658 2.26683 13.7325 1.3335 11.3992 1.3335Z" fill="#59EF79"/>
                    </svg>
                </div>
            </CopyToClipboard>
        </div>
    )
}